import { Component, Input } from '@angular/core';
import { Trainer } from '../../../_services';

@Component({
    selector: 'trainer-card',
    templateUrl: './trainer-card.component.html',
    styleUrls: ['./trainer-card.component.scss'],
})
export class TrainerCardComponent {
    @Input() trainer: Trainer;
    @Input() inline: boolean;

    constructor() {}
}



// WEBPACK FOOTER //
// ./src/app/_screens/_shared/trainer-card/trainer-card.component.ts